import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './cip-register.css';
import { fetchCipRegisters } from './store/slice';
import { actions as CipRegisterActions } from './store/slice';
import CipRegisterModals from './cip-register-modals';
import CipRegisterContent from './cip-register-content';
import CipRegisterTopHead from './cip-register-top-head';

const { resetFilters, setFilterVisible } = CipRegisterActions;

const CipRegisterView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCipRegisters());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false));
    };
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>CIP Register</h4>
                <h6>Manage Continuous Improvement Programs</h6>
              </div>
            </div>
            <CipRegisterTopHead />
          </div>
          <CipRegisterContent />
          <CipRegisterModals />
        </div>
      </div>
    </div>
  );
};

export default CipRegisterView;
